import ApiEndpointConstants from "../constans/ApiEndpointConstants";
import api from "./API";

/**
 * 获取未读消息数量
 * @returns {Promise}
 */
export const get_unread_count = () => {
  // 后端使用GET方法
  return api.get(`${ApiEndpointConstants.GET_UNREAD_COUNT}`);
};

